/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/customer_appCommonService";
import ItemServiceV1 from "../../../services/construction_appCommonService";

const initialState = {
  order_scheduling: {
    data: [],
    status: true,
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  costingSheet: {
    costingSheetID: "",
    quotationID: "",
    data: [],
    status: true,
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  postDispatchDoc: {
    postDispatchDocID: "",
    data: [],
    status: true,
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  creditPolicy: {
    addCreditPolicyID: "",
  },
  customerReg: {
    customerID: "",
    info: {},
  },
  kycExistingCustomer: {},
  material: {
    data: [],
    status: true,
    materialNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  estimation: {
    data: [],
    status: true,
    estimationNr: "",
    quotaiontojob: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  estimationDraft: {
    estimationData: [],
  },
  quotation_Job: {
    data: [],
    status: true,
    quotation_JobNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
};

export const customerV1Slice = createSlice({
  name: "customerV1",
  initialState,
  reducers: {
    addcustomerID(state, action) {
      state.customerID = action.payload;
    },
    addCostingSheetID(state, action) {
      state.costingSheet.costingSheetID = action.payload;
    },
    addQuotationID(state, action) {
      state.costingSheet.quotationID = action.payload;
    },
    addCreditPolicyID(state, action) {
      state.creditPolicy.addCreditPolicyID = action.payload;
    },
    saveCustomerRegData(state, action) {
      state.customerReg.info = action.payload;
    },
    kycExistingCustomer(state, action) {
      state.kycExistingCustomer = action.payload;
    },
    addMaterial(state, action) {
      state.material.materialNr = action.payload;
    },
    addEstimation(state, action) {
      state.estimation.estimationNr = action.payload;
    },
    setEstimationData(state, action) {
      state.estimationDraft.estimationData = action.payload;
    },
    addQuotationh(state, action) {
      state.quotation_Job.quotation_JobNr = action.payload;
    },
    quotationtojob(state, action) {
      state.estimation.quotaiontojob = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderSchedulingList.pending, (state, action) => {
        state.order_scheduling.status = true;
      })
      .addCase(getOrderSchedulingList.fulfilled, (state, action) => {
        state.order_scheduling.data = action.payload.data;
        state.order_scheduling.pagination.page = action.payload.page;
        state.order_scheduling.pagination.per_page = action.payload.per_page;
        state.order_scheduling.pagination.total = action.payload.total;
        state.order_scheduling.status = false;
      })
      .addCase(getPostDispatchDocList.pending, (state, action) => {
        state.postDispatchDoc.status = true;
      })
      .addCase(getPostDispatchDocList.fulfilled, (state, action) => {
        state.postDispatchDoc.data = action.payload.data;
        state.postDispatchDoc.pagination.page = action.payload.page;
        state.postDispatchDoc.pagination.per_page = action.payload.per_page;
        state.postDispatchDoc.pagination.total = action.payload.total;
        state.postDispatchDoc.status = false;
      })
      .addCase(getCostingSheetList.pending, (state, action) => {
        state.costingSheet.status = true;
      })
      .addCase(getCostingSheetList.fulfilled, (state, action) => {
        state.costingSheet.data = action.payload.data;
        state.costingSheet.pagination.page = action.payload.page;
        state.costingSheet.pagination.per_page = action.payload.per_page;
        state.costingSheet.pagination.total = action.payload.total;
        state.costingSheet.status = false;
      })
      .addCase(getMaterialList.pending, (state, action) => {
        state.material.status = true;
      })
      .addCase(getMaterialList.fulfilled, (state, action) => {
        state.material.data = action.payload.data;
        state.material.pagination.page = action.payload.page;
        state.material.pagination.per_page = action.payload.per_page;
        state.material.pagination.total = action.payload.total;
        state.material.status = false;
      })
      .addCase(getEstimationList.pending, (state, action) => {
        state.estimation.status = true;
      })
      .addCase(getEstimationList.fulfilled, (state, action) => {
        state.estimation.data = action.payload.data;
        state.estimation.pagination.page = action.payload.page;
        state.estimation.pagination.per_page = action.payload.per_page;
        state.estimation.pagination.total = action.payload.total;
        state.estimation.status = false;
      })
      .addCase(getQtnJobList.pending, (state, action) => {
        state.quotation_Job.status = true;
      })
      .addCase(getQtnJobList.fulfilled, (state, action) => {
        state.quotation_Job.data = action.payload.data;
        state.quotation_Job.pagination.page = action.payload.page;
        state.quotation_Job.pagination.per_page = action.payload.per_page;
        state.quotation_Job.pagination.total = action.payload.total;
        state.quotation_Job.status = false;
      });
  },
});

export const {
  addcustomerID,
  addCostingSheetID,
  addQuotationID,
  addCreditPolicyID,
  saveCustomerRegData,
  kycExistingCustomer,
  addMaterial,
  addEstimation,
  setEstimationData,
  addQuotationh,
  quotationtojob
} = customerV1Slice.actions;
export default customerV1Slice.reducer;

export const getOrderSchedulingList = createAsyncThunk(
  "getOrderSchedulingList",
  async (param) => {
    console.log(">> loaded getOrderSchedulingList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);

export const getPostDispatchDocList = createAsyncThunk(
  "getPostDispatchDocList",
  async (param) => {
    console.log(">> loaded getPostDispatchDocList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);

export const getCostingSheetList = createAsyncThunk(
  "getCostingSheetList",
  async (param) => {
    console.log(">> loaded getCostingSheetList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);

export const getMaterialList = createAsyncThunk(
  "getMaterialList",
  async (param) => {
    console.log(">> loaded getQtnJobList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);

export const getEstimationList = createAsyncThunk(
  "getEstimationList",
  async (param) => {
    console.log(">> loaded getEstimationList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);

export const getQtnJobList = createAsyncThunk(
  "getQtnJobList",
  async (param) => {
    console.log(">> loaded getQtnJobList");
    const res = await ItemServiceV1.generateCustomerQuery(param);
    return res;
  },
);
